import Notification from '../core/Notification';
import TitledPanel from '../core/TitledPanel';
import { withStyles } from '@material-ui/core/styles';
import { globalStyles as styles } from '../core/style/gstheme';
import { Typography } from '@material-ui/core';
import LinearProgress from '@material-ui/core/LinearProgress';
import PropTypes from 'prop-types';
import React from 'react';
import ActionText from './ActionText';
import Warning from './Warning';
import { makeCancelable } from './utils/utils';
import GS from '../grafsync/grafsync';

// This is the common component for loading statistics
// A view callback is expected to actually render the statistics

class StatisticsLoader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            isLoading: true,
            isErrored: false,
            isFailed: false,
            showLoading: false,
            count: 0,
            errorCount: 0
        };
        this.cancellable = null;
        this.qRef = React.createRef();
    }

    componentDidMount() {
        this.getData();
    }

    componentWillUnmount() {
        if (this.slTimeout) clearTimeout(this.slTimeout);
        if (this.cancellable) this.cancellable.cancel();
    }

    async getData() {
        try {
            if (this.hcTimeout) clearTimeout(this.hcTimeout);
            this.slTimeout = setTimeout(() => {
                if (this.cancellable && this.cancellable.isCancelled()) return;
                this.setState({ showLoading: true });
            }, 2000);
            let fullStats = [];
            let count = 0;
            let errorCount = 0;
            GS.handle("get-stats");
            for (let exportName of this.props.exportNames) {
                // We reset the click idler - we don't want log out kicking in during checking
                if (this.qRef && this.qRef.current) {
                    this.qRef.current.click();
                }
                const exportData = await this.loadData(exportName).promise;
                if (this.cancellable && this.cancellable.isCancelled()) return;
                // Status indicates an eror
                if (exportData.status) {
                    errorCount++;
                }
                else {
                    if (exportData.graph) {
                        fullStats = fullStats.concat(exportData.graph);
                    }
                }
                count++;
                this.setState({ data: fullStats, count, errorCount });
            }
            this.setState({ isLoading: false });
        }
        catch (e) {
            if (!this.cancellable || (this.cancellable && !this.cancellable.isCancelled())) {
                this.setState({
                    isErrored: true,
                    isLoading: false,
                    isFailed: true,
                    message: "Could not load all of the data for the statistics view."
                });
            }
        }

    }

    onExitWarning = () => this.setState({ isErrored: false });

    loadData(exportName) {
        this.cancellable = makeCancelable(GS.export(exportName, this.props.component, this.props.graph, "application/ld+json", null, [], [500]));
        return this.cancellable;
    }

    render() {

        const { isLoading, isErrored, message, isFailed, data, count, errorCount, showLoading } = this.state;
        const { displayView, exportNames, classes } = this.props;

        if (isErrored) return <Warning message={message} onExitWarning={this.onExitWarning} />;
        if (isFailed) return <div style={{ minHeight: 120, margin: 4 }}>
            <ActionText offset="120px">Statistics loading failed.</ActionText>
        </div>;

        return (
            <div>
                {isLoading && showLoading &&
                    <div style={{ margin: '4px' }}>
                        <TitledPanel title={undefined}>
                            <div style={{ height: '93px', paddingTop: '40px' }} ref={this.qRef}>
                                {count < exportNames.length &&
                                    <Typography
                                        data-test="progress-info"
                                        color="secondary"
                                        paragraph
                                        className={classes.mainHeading}
                                        align="center">{count}/{exportNames.length} Sets of Statistics Computed</Typography>
                                }
                                <div style={{ marginLeft: 6 }}>
                                    <LinearProgress
                                        color="secondary"
                                        className={classes.progress}
                                        variant="determinate"
                                        value={count / exportNames.length * 100} />
                                </div>
                            </div>
                        </TitledPanel>
                    </div>
                }
                {errorCount > 0 &&
                    <div style={{ marginTop: 6, marginBottom: 6 }}>
                        <Notification dataTest="errors-happened" text="Some statistics computations failed to run." />
                    </div>
                }
                {displayView(data)}
            </div>
        );
    }
}

StatisticsLoader.propTypes = {
    component: PropTypes.string.isRequired,
    displayView: PropTypes.func.isRequired,
    exportNames: PropTypes.array.isRequired,
    graph: PropTypes.string.isRequired
};

export default withStyles(styles)(StatisticsLoader);